/**
 * Copyright (C) 2021 Viasat, Inc.
 * All rights reserved.
 * The information in this software is subject to change without notice and should not be construed as a commitment by Viasat, Inc.
 *
 * Viasat Proprietary
 * The Proprietary Information provided herein is proprietary to Viasat and
 * must be protected from further distribution and use. Disclosure to others,
 * use or copying without express written authorization of Viasat, is strictly prohibited.
 */

import React from 'react';
import { PanelLabel } from './PanelLabel';
import SwitchOnOff from '../../materialui_wrappers/SwitchOnOff';
 
interface OverlayToggleProps {
    checked: boolean;
    setChecked: (checked: boolean) => void;
    toggleId?: string;
    label: string | React.ReactNode;
    disabled?: boolean;
    style?: React.CSSProperties
}

/**
 * Wrapper for a toggle that is used in the map overlays to turn on and off features.
 */
export function OverlayToggle({
    checked,
    setChecked,
    toggleId,
    label,
    disabled,
    style
}: OverlayToggleProps) { 
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        ...style,
      }}
    >
      <PanelLabel
        data-testid="PanelLabel"
        onClick={(_event: any) => setChecked(!checked)}
        style={{ margin: '0 0 0 16px', cursor: 'pointer' }}
      >
        {label}
      </PanelLabel>

      <SwitchOnOff
        id={toggleId}
        checked={checked}
        onChange={(event: any, checked: boolean) => setChecked(checked)}
        disabled={disabled}
      />
    </div>
  );
}
 
export default OverlayToggle;
 